/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import './TransactionInfoModal.scss';

import { string } from 'prop-types';
import React from 'react';

import TransactionInfo from 'components/layouts/Transaction/TransactionInfo';

import BaseModal from 'components/shared/Modal/BaseModal';

import { detailToContentMap } from 'services/Transactions';

export default class TransactionInfoModal extends BaseModal {
  containerClassName() {
    const { className } = this.props;
    return `modal-info-container modal-transactions-info-container ${className}`;
  }

  renderIcon() {
    return null;
  }

  renderLinkContent() {
    const { linkText, detail } = this.props;
    const icon = super.renderIcon();
    return (
      <div className="transaction-modal-link">
        {linkText || detail}
        {icon}
      </div>
    );
  }

  renderModalContent() {
    const { detail } = this.props;
    const { content } = detailToContentMap[detail];
    return <TransactionInfo content={content} />;
  }

  renderTitleContent() {
    const { detail } = this.props;
    const { title } = detailToContentMap[detail];
    return title;
  }
}

TransactionInfoModal.defaultProps = {
  className: ''
};

TransactionInfoModal.propTypes = {
  className: string,
  detail: string,
  linkText: string
};
